import httpManager from "@/app/shared/utils/httpManager";

/**
 * Get results from an array of groups
 *
 * @return {Promise<Array>} List of results.
 */
export default async function (array) {
  const url = "/entities/results/";
  let query = "?";
  if (array.length > 0) {
    array.forEach((id) => {
      query = query + "&group=" + id;
    });
  }
  const response = await httpManager.get(url + query);

  return response?.data;
}
